module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-bg",
    class: {
      second: _vm.isSecond
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "img conpic",
    class: {
      'img-second': _vm.isSecond
    }
  }, [_c('img', {
    class: {
      'img-second': _vm.isSecond
    },
    attrs: {
      "src": _vm.imgurl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail",
    class: {
      text: !_vm.isSecond, 'text-second': _vm.isSecond
    }
  }, [_c('div', [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.slogan))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('span', [_c('p', [_vm._v(_vm._s(_vm.description))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32c6dae9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/strength_intro/HomeStrengthIntro.vue
// module id = 147
// module chunks = 1